<template>
  <DialogCard :title="theTitle" :actions="actions">
    <v-radio-group v-model="newOrExisting">
      <v-radio value="new" label="Use PMS Book Information to Create a New MH1 Appointment Book"></v-radio>
      <v-radio value="existing" label="Use an Existing MH1 Appointment Book"></v-radio>
    </v-radio-group>
    <v-expand-transition v-show="newOrExisting == 'new'">
    <v-alert v-if="newOrExisting == 'new'" type="warning">
The ability to create a new MH1 Book is under development. For the time being please Use an existing MH1 Appointmnt Book.
    </v-alert>
    
    </v-expand-transition>
    <v-expand-transition v-show="newOrExisting == 'new'">
    <v-form v-if="newOrExisting == 'new'" ref="newBookForm" v-model="newBookFormValid">
      <v-container>
        <v-row align="baseline">
          <v-col cols="8">
            <h5>MH1 Book Input Value</h5>
          </v-col>
          <v-col cols="4">
            <h5>Value Read from PMS Book</h5>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              :rules="[v => !!v || 'First Name is required']"
              label="First Name"
              v-model="newBookDetails.firstName"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>Book: {{getBookFirstName(value)}} <br/>Resource(s): {{getBookResourceFirstName(value)}}</span>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              :rules="[v => !!v || 'Surname is required']"
              label="Surname"
              v-model="newBookDetails.surname"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>Book: {{getBookSurname(value)}}<br/> Resource(s): {{getBookResourceSurname(value)}}</span>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-select
              v-model="newBookDetails.gender"
              :items="genders"
              label="Gender"
              item-text="label"
              item-value="id"
              
            ></v-select>
          </v-col>
          <v-col cols="4">
            <span>{{getBookResourceSex(value)}}</span>
          </v-col>
        </v-row>
        

        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              :rules="emailRules"
              label="Email"
              v-model="newBookDetails.email"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>{{getBookResourceEmails(value)}}</span>
          </v-col>
        </v-row>


        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              :rules="[v => !!v || 'Mobile Phone is required']"
              label="Mobile Phone"
              v-model="newBookDetails.phone"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>{{value.phone}}</span>
          </v-col>
        </v-row>


        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              :rules="[v => !!v || 'Position is required']"
              label="Position"
              v-model="newBookDetails.position"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>{{getBookResourcePositions(value)}}</span>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
             <v-autocomplete
             :loading="serviceTypesLoading"
              v-model="newBookDetails.primaryServiceType"
              :items="serviceTypes"
              label="Primary Service Type"
              item-text="name"
              item-value="id"
              required 
              :rules="[v => !!v || 'Primary Service Type is required']" 
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <span></span>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <h4>Calendar Settings</h4>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-autocomplete
              v-model="newBookDetails.timezone"
              :items="timeZoneNames"
              label="Time Zone"
              required 
              :rules="[v => !!v || 'Timezone is required']" 
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <span>{{siteTimeZone}}</span>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-text-field
              required
              type="number"
              :rules="[v => !!v || 'Calendar Slot Duration is required']"
              label="Calendar Slot Duration in Minutes"
              v-model="newBookDetails.slotDuration"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <span>{{tryParseISO8601DurationToMinutes(getSlotSize(value))}}</span>
          </v-col>
        </v-row>



        <v-row>
          <v-col cols="4">
            <h4>Bookable Hours</h4>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template>
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>Open</th>
                    <th>Start Hour</th>
                    <th>End Hour</th>
                    <th>PMS Data</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(day,index) in ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']"
                    :key="index"
                  >
                    <td>{{day}}</td>
                    <td>
                      <v-switch v-model="newBookDetails.openingHours[day.toLowerCase()].open"></v-switch>
                    </td>
                    <td>
                      <vue-timepicker
                        :disabled="!newBookDetails.openingHours[day.toLowerCase()].open"
                        format="h:mm A"
                        :minute-interval="5"
                        v-model="newBookDetails.openingHours[day.toLowerCase()].start"
                      ></vue-timepicker>
                    </td>
                    <td>
                      <vue-timepicker
                        :disabled="!newBookDetails.openingHours[day.toLowerCase()].open"
                        format="h:mm A"
                        :minute-interval="5"
                        v-model="newBookDetails.openingHours[day.toLowerCase()].end"
                      ></vue-timepicker>
                    </td>
                    <td>
                      <span
                        v-if="siteWeeklySchedule"
                      >{{getSiteStartHourForDay(day.toLowerCase())}} - {{getSiteEndHourForDay(day.toLowerCase())}}</span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4">
            <h4>Admin Details</h4>
          </v-col>
        </v-row>


        <v-row align="baseline">
          <v-col cols="8">
            <v-select
              required 
              :rules="[v => !!v || 'Status is required']"
              label="Status"
              :items="mh1AppointmentBookStatus"
              v-model="newBookDetails.status"
             >
            </v-select>
          </v-col>
          <v-col cols="4">
            <span></span>
          </v-col>
        </v-row>

        <v-row align="baseline">
          <v-col cols="8">
            <v-menu
        v-model="expirationDateMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="newBookDetails.expirationDate"
              required
              :rules="[v => !!v || 'Expiration Date is required']"
              label="Expiration Date"
            v-bind="attrs"
            v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker v-model="newBookDetails.expirationDate" @input="expirationDateMenu = false"></v-date-picker>
      </v-menu>
          </v-col>
          <v-col cols="4">
            <span></span>
          </v-col>
        </v-row>

      </v-container>
    </v-form>
    </v-expand-transition>
    <v-expand-transition v-show="newOrExisting == 'existing'">
    <span v-if="newOrExisting == 'existing'">
      <v-select
        placeholder="Select an MH1 Appointment Book"
        :solo="true"
        :items="availableMh1AppointmentBooks"
        :item-text="item => item.subscriber.name + ' ' + item.subscriber.surname"
        item-value="id"
        v-model="selectedMh1BookId"
      ></v-select>
      <ul>
          <li>PMS Default Slot Size: {{displaySlotSize(pmsBaseSlotSize)}}</li>
          <li>PMS Site Default Slot Size: {{displaySlotSize(siteBaseSlotSize)}} </li>
          <li>PMS Book Slot Size: {{displaySlotSize(getBookSlotSize(value))}}</li>
          <li v-if="selectedMh1BookId">MH1 Book Slot Size: {{selectedMh1Book.slotSize}} minutes</li>

      </ul>
      <v-alert v-if="slotSizeNotDetected(value)" type="warning">
        Unable to detect the slot size used in the PMS. Please confirm with the practice that the MH1 slot size matches their setup.
      </v-alert>
      <v-alert type="error" v-else-if="selectedMh1BookId && isIncompatibleSlotSize(value)">
        The MH1 Appointment Book slot size is compatible with the slot size set in the PMS.
        The slot size in MH1 should match that in the PMS, or be a multiple.
        For example, if the slot size in the PMS is 15 minutes in MH1 you should use 15 or if higher, 30, 45, 60, etc.
      </v-alert>
      <v-alert type="warning" v-else-if="selectedMh1BookId && isMultipleSlotSize(value)">
        The MH1 Appointment Book slot size is a multiple of the PMS appointment book. 
        Consider setting the Mh1 Book's slot size to the same as the PMS to avoid confusion.
      </v-alert>
      <v-alert v-else-if="selectedMh1BookId" type="info">
        All checks out, slot size of PMS and MH1 Book match.
      </v-alert>
    </span>
    </v-expand-transition>
    <!--
    <v-card-actions>
      <v-btn color="secondary">Cancel</v-btn>
      <v-spacer></v-spacer>
      <v-btn right color="primary" @click="doOk()">OK</v-btn>
    </v-card-actions>
    -->
  </DialogCard>
</template>
<script>
import VueTimepicker from 'vue2-timepicker'
import { timeZonesNames } from "@vvo/tzdb";

const iso8601DurationRegex = /(-)?P(?:([.,\d]+)Y)?(?:([.,\d]+)M)?(?:([.,\d]+)W)?(?:([.,\d]+)D)?T(?:([.,\d]+)H)?(?:([.,\d]+)M)?(?:([.,\d]+)S)?/;

export default {
  name: "AddBookDialog",
  components: {VueTimepicker},
  props: {
    value: Object,
    availableMh1AppointmentBooks: Array,
    siteWeeklySchedule: Object,
    serviceTypes: Array,
    serviceTypesLoading: Boolean,
    siteBaseSlotSize: String,
    pmsBaseSlotSize: String,
    siteTimeZone: String
  },
  data() {
    return {
      newOrExisting: "new",
      selectedMh1BookId: "",
      expirationDateMenu: false,
      newBookDetails: {
        firstName: "",
        surname: "",
        gender: "",
        email: "",
        phone: "",
        position: "",
        primaryServiceType: "",
        timeZone: "",
        slotDuration: 15,
        status: "",
        expirationDate: "",
        openingHours: {
          monday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          tuesday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          wednesday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          thursday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          friday: {
            open: true,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          saturday: {
            open: false,
            start: "9:00 AM",
            end: "5:00 PM",
          },
          sunday: {
            open: false,
            start: "9:00 AM",
            end: "5:00 PM",
          },
        },
      },
      newBookFormValid: false,
      mh1Books: [],
      genders: [{label: "Female", id:"F"},{label: "Male", id: "M"}],
      timeZoneNames: [],
      mh1AppointmentBookStatus: ["ON_HOLD_TECHNICAL"],
      emailRules: [
                v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'

      ]
    };
  },
  computed: {
    theTitle: function () {
      return `Add Book ${this.getBookDisplayName(this.value)}`;
    },
    isValid: function () {
      if (this.newOrExisting == "new") {
        return false;
        //return this.$refs.newBookForm.validate();
      } else {
        return this.selectedMh1BookId;
      }
    },
    selectedMh1Book: function() {
      if (!this.selectedMh1BookId) {
        return null;
      }
      return this.availableMh1AppointmentBooks.find(b => b.id === this.selectedMh1BookId);
    },
    actions: function () {
      return {
        cancel: {
          text: "Cancel",
          color: "secondary",
          handle: () => {
            return { ...this.value, action: "cancelled" };
          },
        },
        ok: {
          text: "OK",
          color: "primary",
          disabled: () => {
            const isValid = this.isValid;
            console.log(
              "checking disabled",
              this.newOrExisting,
              this.newBookFormValid,
              this.selectedMh1BookId,
              isValid
            );
            return !isValid;
          },
          handle: () => {
            if (!this.isValid) {
              return false;
            }

            return {
              ...this.value,
              newOrExisting: this.newOrExisting,
              selectedMh1BookId: this.selectedMh1BookId,
              newBookDetails: this.newBookDetails,
              action: "ok",
            };
          },
        },
      };
    },
  },
  created: function () {
    this.timeZoneNames = timeZonesNames;
    this.fillFromPMSInfo();


  },
  methods: {
    fillFromPMSInfo: function () {
      //this.newBookDetails.bookName = this.getBookDisplayName(this.value);
      this.newBookDetails.firstName = this.getFirstName(this.value);
      this.newBookDetails.surname = this.getSurname(this.value);

      this.newBookDetails.email = this.getBookResourceEmails(this.value)?.[0] ?? "";
      this.newBookDetails.phone = this.getBookResourceMobilePhones(this.value)?.[0] ?? "";

      this.newBookDetails.slotDuration = this.tryParseISO8601DurationToMinutes(this.getSlotSize(this.value));

      this.newBookDetails.timeZone = this.siteTimeZone ?? "";

      this.newBookDetails.expirationDate = new Date(new Date().setFullYear(new Date().getFullYear() + 50)).toISOString().substr(0, 10);

      if (!this.siteWeeklySchedule || Object.keys(this.siteWeeklySchedule).length == 0) {
        return;
      }

      for (const day of ['monday','tuesday','wednesday','thursday','friday','saturday','sunday']) {
        if (!this.siteWeeklySchedule[day] || this.siteWeeklySchedule[day].length == 0) {
          this.newBookDetails.openingHours[day].open = false;
        }
        else {
          const dayData= this.siteWeeklySchedule[day];

          const start24 = dayData.map(d => d.start).sort()[0];
          const end24 = dayData.map(d => d.end).sort().reverse()[0];
          const start12 = new Date("2000-01-01T"+start24).toLocaleString("en-US", {hour:'numeric',minute:'numeric',hour12: true});
          const end12 = new Date("2000-01-01T"+end24).toLocaleString("en-US", {hour:'numeric',minute:'numeric',hour12: true});

          this.newBookDetails.openingHours[day].open = true;
          this.newBookDetails.openingHours[day].start = start12;
          this.newBookDetails.openingHours[day].end = end12;
        }
      }
    },
    validateNewBookForm() {
      this.$refs.newBookForm.validate();
    },
    doOk: function () {
      this.$emit("input", this.value);
    },
    getBookResourceFirstName: function(bi) {
      return bi.resources
          ?.map((r) => {
            if (r.firstName) {
              return [r.title ?? "", r.firstName ?? ""].filter(n => !!n).join(" ");
            }
            else if (r.name) {
              return [r.title ?? "", r.name?.split(' ').slice(0,-1) ?? ""].filter(n => n).join(" ");
            } else {
              return "";              
            }
          })
          ?.join(", ") ?? "";
    },
    getBookFirstName: function (bi) {
      return (bi.book?.name?.split(' ').slice(0,-1).join(' ') ?? "");
    },
    getFirstName: function(bi) {
      return this.getBookFirstName(bi) || this.getBookResourceFirstName(bi);
    },
    getBookResourceSurname: function(bi) {
      return bi.resources
          ?.map((r) => {

            if (r.surname) {
              return `${r.surname ?? ""}`;
            }
            else if (r.name) {
              return `${r.name?.split(' ').slice(-1)[0] ?? ""}`;
            } 
            else {
              return "";
            }
          })
          ?.join(", ") ?? "";
    },
    getBookSurname: function(bi) {
      return (bi.book?.name?.split(' ').slice(-1)[0] ?? "")
    },
    getSurname: function(bi) {
      return this.getBookSurname(bi) || this.getBookResourceSurname(bi);
    },
    getBookResourceSex: function(bi) {
      return bi.resources?.map(r => r.sex).filter(s => !!s) ?? [];
    },
    getBookResourceEmails: function(bi) {
      return bi.resources?.map(r => r.contactEmail).filter(s => !!s) ?? [];
    },
    getBookResourceMobilePhones: function(bi) {
      return bi.resources?.map(r => r.contactMobilePhone).filter(s => !!s) ?? [];
    },
    getBookResourcePositions: function(bi) {
      return bi.resources?.map(r => r.position).filter(s => !!s) ?? [];
    },
    getBookDisplayName: function (bi) {
      return (
        bi.book.name ??
        bi.resources
          ?.map((r) => {
            if (r.name) {
              return `${r.title ?? ""} ${r.name ?? ""}`;
            } else {
              return `${r.title ?? ""} ${r.firstName ?? ""} ${r.surname ?? ""}`;
            }
          })
          ?.join(", ") ??
        "" ??
        bi.book.pmsBookFQId
      );
    },
    slotSizeNotDetected: function(value) {
      return this.getSlotSize(value) == '' || this.getSlotSize(value) == 'PT0S';
    },
    isIncompatibleSlotSize: function(bi) {
      const pmsStr = Number(this.tryParseISO8601DurationToMinutes(this.getSlotSize(bi)));
      const mh1Str = this.selectedMh1Book?.slotSize;

      if (!pmsStr || !mh1Str) { 
        return true;
      }

      const pms = Number(pmsStr);
      const mh1 = Number(mh1Str);

      if (mh1 === pms) {
        return false;
      }
      else if (mh1 % pms == 0) { 
        console.log(`${pms} % ${mh1} == ${pms % mh1}`);
        return false;
      }
      else {
        return true;
      }
    },
    isMultipleSlotSize: function(bi) {
      const pmsStr = Number(this.tryParseISO8601DurationToMinutes(this.getSlotSize(bi)));
      const mh1Str = this.selectedMh1Book?.slotSize;

      const pms = Number(pmsStr);
      const mh1 = Number(mh1Str);
      console.log(`isMultipleSlotSize ${pms} ${mh1}`);
      if (mh1 % pms == 0 && mh1 !== pms) {
        return true;
      } else {
        return false;
      }
    },
    getSlotSize: function(bi) {
      console.log("getSlotSize for", bi);
      if (bi.book?.baseSlotSize && bi.book?.baseSlotSize != "PT0S") {
        console.log("getSlotSize bi.book.baseSlotSize", bi.book.baseSlotSize);
        return bi.book.baseSlotSize;
      }

      if (bi.resouces?.length > 0) {
        console.log("getSlotSize bi.resouces.length > 0");
          const uniqueSlotSizes = [...new Set(bi.resources.map(r => r.baseSlotSize).filter(s => !!s) ?? [])];

        console.log("getSlotSize uniqueSlotSizes", uniqueSlotSizes);
          if (uniqueSlotSizes.length == 1) {
            return uniqueSlotSizes[0];
          }
      }
      console.log("getSlotSize this.siteBaseSlotSize || this.pmsBaseSlotSize || ", this.siteBaseSlotSize, this.pmsBaseSlotSize);
      return this.siteBaseSlotSize || this.pmsBaseSlotSize || "";
      

    },
    getBookSlotSize: function(bi) {
      console.log("getSlotSize for", bi);
      if (bi.book?.baseSlotSize && bi.book?.baseSlotSize != "PT0S") {
        console.log("getSlotSize bi.book.baseSlotSize", bi.book.baseSlotSize);
        return bi.book.baseSlotSize;
      }

      if (bi.resouces?.length > 0) {
        console.log("getSlotSize bi.resouces.length > 0");
          const uniqueSlotSizes = [...new Set(bi.resources.map(r => r.baseSlotSize).filter(s => !!s) ?? [])];

        console.log("getSlotSize uniqueSlotSizes", uniqueSlotSizes);
          if (uniqueSlotSizes.length == 1) {
            return uniqueSlotSizes[0];
          }
      }
      return "";
      

    },
    getSiteStartHourForDay: function(day) {
      if (!this.siteWeeklySchedule) {
        return "";
      }
      const start24 = this.siteWeeklySchedule[day.toLowerCase()]?.map(d => d.start)?.sort()[0]  || "";
      if (start24 == "") {
        return "";
      }
      return new Date("2000-01-01T"+start24).toLocaleString("en-US", {hour:'numeric',minute:'numeric',hour12: true});
    },
    getSiteEndHourForDay: function(day) {
      if (!this.siteWeeklySchedule) {
        return "";
      }
      const end24 = this.siteWeeklySchedule[day.toLowerCase()]?.map(d => d.end)?.sort()?.reverse()[0]  || "";
      if (end24 == "")  {
        return "";
      }
      return new Date("2000-01-01T"+end24).toLocaleString("en-US", {hour:'numeric',minute:'numeric',hour12: true});
    },
    tryParseISO8601Duration: function(value) {
      try {
        const matches = value.match(iso8601DurationRegex);

        const r = {
            sign: matches[1] === undefined ? '+' : '-',
            years: matches[2] === undefined ? 0 : matches[2],
            months: matches[3] === undefined ? 0 : matches[3],
            weeks: matches[4] === undefined ? 0 : matches[4],
            days: matches[5] === undefined ? 0 : matches[5],
            hours: matches[6] === undefined ? 0 : matches[6],
            minutes: matches[7] === undefined ? 0 : matches[7],
            seconds: matches[8] === undefined ? 0 : matches[8]
        };

        console.log("tryParseISO8601DurationToHoursMinutes matched", value, r);

        return r;

        return `${r.hours?.toString().padStart(2,'0') || "00"}:${r.minutes?.toString().padStart(2,'0') || "00"}`;
      }
      catch(err){
        console.log("tryParseISO8601DurationToMinutes err", value, err)
        return value;
      }
    },
    tryParseISO8601DurationToHoursMinutes: function(value) {
      const r = this.tryParseISO8601Duration(value);

      if (r == value) {
        return r;
      }

      return `${r.hours?.toString().padStart(2,'0') || "00"}:${r.minutes?.toString().padStart(2,'0') || "00"}`;
    },
    tryParseISO8601DurationToMinutes: function(value) {
      const r = this.tryParseISO8601Duration(value);

      if (r == value) {
        return r;
      }

      return Number(r.minutes) + (Number(r.hours) * 60) + (Number(r.days) * 24 * 60);
    },
    displaySlotSize: function(value) {
      const mins = this.tryParseISO8601DurationToMinutes(value);
      const minsInt = parseInt(mins);
      if (!minsInt) {
        return "Not detected";
      }
      else {
        return `${mins} minute` + (minsInt ? 's' : '');
      }
    }

  },
};
</script>